import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import HomeIcon from "../../../images/home-icon-menu.svg";
import WishlistIconGrey from "../../../images/WishlistIconGrey.svg";
import SearchIcon from "../../../images/Search-icon-menu.svg";
import ProfileIcon from "../../../images/profile-icon-menu.svg";
import FidIcon from "../../../images/FID-icon.svg";
import GiftIconWhite from "../../../images/GiftIconWhite.svg";

import ProfileIconProfile from "../../../images/profile-icon-primary.svg";
import CommandsIconProfile from "../../../images/Commands-icon-primary.svg";
import FidIconProfile from "../../../images/FID-icon-primary.svg";
import logoutwhite from "../../../images/logout-white.svg";
import MesCommandesIcon from "../../../images/MesCommandesIcon.svg";

interface MobileMenuNavProps {
  restaurantId: string | undefined;
  onClickHome: () => void;
  onClickAdresse: () => void;
  onClickSearch: () => void;
  onClickFID: () => void;
  onClickMyprofile: () => void;
  onClickCommands: () => void;
  clearItemStore?: (key: string) => void;
  logout?: () => void;
  setLogoutRetries?: (value: number) => void;
}

export default function MobileMenuNav({
  restaurantId,
  onClickHome,
  onClickAdresse,
  onClickSearch,
  onClickFID,
  onClickMyprofile,
  onClickCommands,
  clearItemStore = () => {},
  logout = () => {},
  setLogoutRetries,
}: MobileMenuNavProps) {
  const navigate = useNavigate();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  const logoutUser = () => {
    localStorage.removeItem("accessToken");
    clearItemStore("auth3dthird");
    clearItemStore("authGoogleSuccess");
    clearItemStore("authAppleSuccess");

    if (localStorage.getItem("token")) {
      localStorage.removeItem("token");
    }

    logout();
    if (setLogoutRetries) {
      setLogoutRetries(Math.random() * 26);
    }
    navigate("/");
  };

  return (
    <div className="Mobile-sideBar">
      <div className="MobileMenuNav">
        <div className="menu-wrapper">
          <div className="menu-elements">
            <div className="menu-items fl_row jc_s">
              <div
                className="menu-item-wrapper fl_col ai_c"
                onClick={onClickHome}
              >
                <img src={HomeIcon} alt="Home" />
                <p>Accueil</p>
              </div>
              <div
                className="menu-item-wrapper fl_col ai_c"
                onClick={onClickAdresse}
              >
                <img src={WishlistIconGrey} alt="Favoris" />
                <p>Favoris</p>
              </div>
              {restaurantId ? (
                <div
                  className="main-menu"
                  onClick={() => navigate(`/${restaurantId}/restaurant-fiofid`)}
                >
                  <div>
                    <img src={FidIcon} alt="FID" />
                  </div>
                </div>
              ) : (
                <div className="main-menu" onClick={onClickFID}>
                  <div>
                    <img src={GiftIconWhite} alt="FID" />

                  </div>
                </div>
              )}
              <div
                className="menu-item-wrapper fl_col ai_c"
                onClick={onClickCommands}
              >
                <img src={MesCommandesIcon} alt="Commandes" />
                <p>Commandes</p>
              </div>
              <div
                className="menu-item-wrapper fl_col ai_c"
                onClick={() => setShowProfileMenu((prev) => !prev)}
              >
                <img src={ProfileIcon} alt="Profile" />
                <p>Profile</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={`profile-menu ${showProfileMenu ? "active-profile" : ""}`}
      >
        <div className="menu-wrapper fl_col jc_s">
          <div className="fl_col ai_c jc_c" onClick={onClickMyprofile}>
            <img src={ProfileIconProfile} alt="Mon Profile" />
            <p>Mon Profile</p>
          </div>
          <div className="fl_col ai_c jc_c" onClick={onClickCommands}>
            <img src={CommandsIconProfile} alt="Mes commandes" />
            <p>Mes commandes</p>
          </div>
          <div className="fl_col ai_c jc_c">
            <img
              src={FidIconProfile}
              alt="FIOFID"
              onClick={() => {
                setShowProfileMenu(false)
                navigate(`/Fiofid`)
              }}
            />
            <p>FIOFID</p>
          </div>
          <div className="fl_row logout-btn ai_c gp20" onClick={logoutUser}>
            <img src={logoutwhite} alt="Se déconnecter" />
            <p>Se déconnecter</p>
          </div>
        </div>
      </div>
    </div>
  );
}
